// extracted by mini-css-extract-plugin
export default {"wrapper":"kmpHfgshvLhK8cClC1To","dataConnectionsList":"SsXfrAiCBD_KOcNSotR8","dataConnectionsListItem":"W7FHFz3iU4MuA6CXcjo6"};